import { MappableModel } from '@se-po/shared-data-access-models'

export class EligibilityCredential extends MappableModel {
  public completed_at: string
  public created_at: string
  public credential_data?: any
  public credential_label: string
  public credential_description: string
  public credential_set_organization_id: number
  public credential_system: string
  public credential_type: string
  public credential_value: string
  public display_name: string
  public effective_at: string
  public eligibility_rule_id: string
  public eligibility_rule_set_ids: string[]
  public eligibility_status: string
  public expires_at: string
  public linked_eligibility_rule_set_id: string
  public rule_system: string
  public rule_type: string
  public rule_value: string
  public status: string
  public trigger: boolean

  public isEqual(credential: EligibilityCredential): boolean {
    return this.credential_type === credential.credential_type &&
      this.credential_system === credential.credential_system &&
      this.credential_value === credential.credential_value &&
      this.credential_set_organization_id === credential.credential_set_organization_id
  }

  public isRuleEqual(credential: EligibilityCredential): boolean {
    return this.rule_type === credential.rule_type &&
      this.rule_system === credential.rule_system &&
      this.rule_value === credential.rule_value
  }

  public parseCredentialData(): any {
    let credentialData = null
    try {
      credentialData = JSON.parse(this.credential_data)
    } catch (error) {
      return null
    }
    return credentialData ? credentialData : this.credential_data
  }
}
